export default __webpack_public_path__ + "static/media/baptism1.19f57ff8.jpg";